import moment from 'moment-timezone'

export const formatDate = (dateString: string): string => {
  const datePart = dateString.split('T')[0]
  const [year, month, day] = datePart.split('-')
  return `${day}/${month}/${year}`
}

export const formatTime = (timeString: string): string => {
  const [hours, minutes] = timeString.split(':')
  return `${hours}:${minutes}`
}

export const formatDateTime = (dateString: string, timeString: string): string => {
  return `${formatDate(dateString)} - ${formatTime(timeString)}`
}

export const getEventTimestamps = (item: { 
  start_date: string
  start_time: string
  end_date: string
  end_time: string
  utc_offset: string 
}) => {
  if (!item) return { now: null, startDateTime: null, endDateTime: null }
  
  const offsetHours = parseInt(item.utc_offset.split(':')[0])
  const now = moment().utcOffset(offsetHours * 60)
  
  const startDateTime = moment.tz(`${item.start_date} ${item.start_time}`, 'UTC').utcOffset(offsetHours * 60, true)
  const endDateTime = moment.tz(`${item.end_date} ${item.end_time}`, 'UTC').utcOffset(offsetHours * 60, true)
  
  return { now, startDateTime, endDateTime }
}

export const getEventStatus = (item: {
  start_date: string
  start_time: string
  end_date: string
  end_time: string
  utc_offset: string
  enabled: boolean
  error?: string | null
}) => {
  const { now, startDateTime, endDateTime } = getEventTimestamps(item)
  
  if (!now || !startDateTime || !endDateTime) {
    return { isFinished: false, isSuspended: false, isUpcoming: false, isActive: false, hasError: false }
  }

  const isFinished = now.isAfter(endDateTime)
  const isSuspended = !item.enabled
  const isUpcoming = now.isBefore(startDateTime)
  const isActive = now.isSameOrAfter(startDateTime) && now.isSameOrBefore(endDateTime) && item.enabled
  const hasError = Boolean(item.error)
  
  return { isFinished, isSuspended, isUpcoming, isActive, hasError }
}

export const formatDuration = (item: {
  start_date: string
  start_time: string
  end_date: string
  end_time: string
// eslint-disable-next-line @typescript-eslint/no-explicit-any
}, t: (key: string, options?: any) => string): string => {
  const startDateTime = moment(`${item.start_date} ${item.start_time}`, 'YYYY-MM-DD HH:mm:ss')
  const endDateTime = moment(`${item.end_date} ${item.end_time}`, 'YYYY-MM-DD HH:mm:ss')
  
  const duration = moment.duration(endDateTime.diff(startDateTime))
  const days = Math.floor(duration.asDays())
  const hours = duration.hours()
  const minutes = duration.minutes()
  
  if (days === 0 && hours === 0) {
    return t('event_ssids.duration.minutes', { count: minutes })
  }
  
  if (days === 0) {
    return t('event_ssids.duration.hours', { count: hours })
  }
  
  if (days === 1 && hours === 0) {
    return t('event_ssids.duration.one_day')
  }
  
  if (hours === 0) {
    return t('event_ssids.duration.days', { count: days })
  }
  
  const dayLabel = t(`event_ssids.duration.day${days > 1 ? '_plural' : ''}`)
  const hourLabel = t(`event_ssids.duration.hour${hours > 1 ? '_plural' : ''}`)
  
  return t('event_ssids.duration.days_and_hours', { days, dayLabel, hours, hourLabel })
}